import React from 'react'
import { Container, Row,Col } from 'react-bootstrap'

const Contact = () => {
  return (
    <Container>
    <Row className="text-center"  style={{margin:"2rem 0"}}>
        <h3 className='homepage-head'>Get Started Today
</h3>
        <p className='text' style={{ fontSize: '0.9em', margin: '0 auto' }}>Ready to take your writing to the next level? Sign up now and submit your essay for professional <br /> grading and feedback. At Writers Wright Grading, we are committed to your academic success.
</p>
    </Row>
    <Row className="text-center" style={{ display: "flex", justifyContent: "center", margin: "8rem 0" }}>
      <Col lg={6} md={6} sm={12} style={{ padding: "0 11%" }}>
        <h4 style={{ color: "var(--primary)", fontWeight: "bold" }}>Contact Us</h4>
        <p style={{ margin: "1rem 0" }}>
          Have questions or need assistance? Reach out to our support team at 
          <a href="mailto:info@wright.com" style={{ marginLeft: "0.2rem",color:"#526082" }}>info@writerswright.com</a> or call us at 
          <a href="tel:+630638278607" style={{ marginLeft: "0.2rem" ,color:"#526082"}}>(063) 827-8607</a>.
        </p>
      </Col>
      <Col lg={6} md={6} sm={12} style={{ padding: "0 11%" }}>
        <h4 style={{ color: "var(--primary)", fontWeight: "bold" }}>Follow Us</h4>
        <p style={{ margin: "1rem 0" }}>
          Stay updated with the latest tips and offers by following us on social media:
          <span style={{ marginLeft: "0.2rem" }}>Facebook | Twitter | Instagram | LinkedIn</span>
        </p>
      </Col>
    </Row>
    </Container>
  )
}

export default Contact
